import * as FullStory from "@fullstory/browser";
import { AnalyticsEvent } from "pages/application/applicationService";

/**
 * @param stepCode internal code for the step
 * @param stepLabel String name for StepCode
 * @param skipped true if user skip
 */
export function trackFSStepCompleted(stepCode: string, stepLabel: string, skipped: boolean) {
  if (!window.env.ENABLE_FULL_STORY) return;
  FullStory.event("Step completed", {
    StepCode: stepCode,
    StepName: stepLabel,
    Skipped: skipped ? "Yes" : "No",
  });
}

export function trackFSApplicationStarted(props: {
  leadProvider?: string;
  loanType?: string;
  pathSelected?: string;
  leadCampaign?: string;
  applicationStartedDate: string;
  loanOfficerAssigned?: string;
}) {
  if (!window.env.ENABLE_FULL_STORY) return;

  const { leadProvider, loanType, pathSelected, leadCampaign, loanOfficerAssigned, applicationStartedDate } = props;

  FullStory.event("Application Started", {
    StartedDate: applicationStartedDate,
    LeadProvider: leadProvider ?? "Unknown",
    LeadCampaign: leadCampaign ?? "Unknown",
    LoanType: loanType ?? "Unknown",
    PathSelected: pathSelected ?? "Unknown",
    LoanOfficerAssigned: loanOfficerAssigned ?? "Not Assigned",
    Environment: (window.env.ENVIRONMENT as string) ?? "Unknown",
  });
}

const trackFSSummaryEvent = (eventType: string, eventPayload: Record<string, any>) => {
  if (!window.env.ENABLE_FULL_STORY) return;

  FullStory.event(eventType, {
    ...eventPayload,
  });
};

const trackFSSummaryEditEvent = (stepCode: string) => {
  if (!window.env.ENABLE_FULL_STORY) return;

  FullStory.event("Summary Page Edited", {
    SummaryPage: stepCode,
  });
};

const trackFSOptedVoaEvent = (orderDate: Date) => {
  if (!window.env.ENABLE_FULL_STORY) return;

  FullStory.event("Opted Voa", { VoaOrderDate: orderDate });
};

const initFullStory = () => {
  window.env.ENABLE_FULL_STORY && FullStory.init({ orgId: window.env.FULLSTORY_ORG_ID });
};

const setFSNavigatedToInsuranceCustomEvent = (nhDealApplicationId: string, redirectionUrl: string) => {
  window.env.ENABLE_FULL_STORY &&
    FullStory.event("NavigatedToInsurance", {
      nhDealApplicationId,
      redirectionUrl,
    });
};

const setFSUserProperties = (email?: string, lastName?: string) => {
  window.env.ENABLE_FULL_STORY &&
    email &&
    FullStory.setUserVars({
      email: email,
    });
  window.env.ENABLE_FULL_STORY &&
    lastName &&
    FullStory.setUserVars({
      lastName: lastName,
    });
};

interface AnalyticsSection {
  section: string;
  eventType: AnalyticsEvent;
  displayName: string;
}
export const analyticsSections: AnalyticsSection[] = [
  { section: "Lead", eventType: "FSLeadCompleted", displayName: "Lead Completed" },
  { section: "Profile", eventType: "FSProfileCompleted", displayName: "Profile Completed" },
  { section: "Property", eventType: "FSPropertyCompleted", displayName: "Property Completed" },
  { section: "Credit", eventType: "FSCreditCompleted", displayName: "Credit Completed" },
  { section: "Finances", eventType: "FSFinanceCompleted", displayName: "Finance Completed" },
  { section: "Acknowledgements", eventType: "FSInitialAppCompleted", displayName: "Initial App Submitted" },
];

export {
  initFullStory,
  setFSUserProperties,
  setFSNavigatedToInsuranceCustomEvent,
  trackFSSummaryEvent,
  trackFSSummaryEditEvent,
  trackFSOptedVoaEvent,
};
